import highcharts from "highcharts";

export default function (angularModule) {
  angularModule.controller('RevGenDashboardCtrl', function (campaign, $state, $scope, reviewGenService, $q, stringService, $stateParams, $location, $window, confirmService, updateService, campaignManagerService, $timeout, userService, locationService, user, reactContainer) {

    $scope.state = "Loading";
    $scope.campaign = campaign;
    $scope.canModifyCampaign = _.includes(user.permissions, 'UserManagement') || campaign.creatorId === user.userId;

    $scope.pageStrings = stringService.adminStrings();

    var panes = ["userEngagement", "campaignSummary", "emailDetails", "smsDetails", "formDetails"];

    $scope.ui = {}

    $scope.Math = $window.Math
    $scope.moment = require('moment');

    $scope.$watch(() => (locationService.getSelectedGroupId()),(newVal,oldVal) => {
      if(newVal !== oldVal){
        setGroupId(newVal)
        getReportData()
      }
    })

    const setGroupId = (id) => {
      $scope.groupId = id ? id : locationService.getSelectedGroupId()
    }

    setGroupId()

    $q.all({
      currentUser: userService.currentUser(false),
    }).then(({currentUser}) => {
      $scope.userInfo = currentUser;
      getReportData()
    })

    $scope.shouldUseGroupId = () => {
      /*params.groupId = groupId;*/
      return $scope.groupId && $scope.groupId.search(/^all-/)==-1
    }


    panes.map((item) => $scope.ui[item] = {collapse: false});

    const getReportData = () => {
      $scope.state = "Loading";
      if (campaign) {
        let params = {}
        if ($scope.shouldUseGroupId()) {
          params.groupId = $scope.groupId
        }
        reviewGenService.getCampaignReport(campaign._id.$oid, params).then(function (reportResp) {
          $scope.data = reportResp.data;
          drawHighCharts($scope.data);
          $scope.state = "Success";
        })
      }
      else {
        $scope.state = "NoCampaigns";
      }
    }

    $scope.toggleActive = function (campaign) {
      if (!campaign.isActive) {
        reviewGenService.findNewCampaignContacts(campaign._id.$oid).then(function (contacts) {
          if (contacts.length > 0) {
            confirmService.confirm("Activate Campaign", "Activating this campaign will send requests to " + contacts.length + " of your contacts.  Continue?", confirmService.WARNING)
              .then(function (proceed) {
                if (proceed) {
                  campaign.isActive = true;
                  reviewGenService.updateCampaign(campaign).then(function (response) {
                    processActivation(response)
                  });
                }
              })
          } else {
            campaign.isActive = true;
            reviewGenService.updateCampaign(campaign).then(function (response) {
              processActivation(response)
            });
          }
        })
      } else {
        campaign.isActive = false;
        reviewGenService.updateCampaign(campaign).then(function (response) {
          processActivation(response)
        });
      }
    };

    $scope.openConfirmDeleteCampaignModal = function (campaign) {
      $scope.campaign = angular.copy(campaign);
      $('#confirmDeleteCampaignModal').modal();
    };

    $scope.deleteCampaign = function (campaign) {

      confirmService.confirmWithOptions({
        heading: 'Delete Confirmation',
        message: `Are you sure you want to delete the campaign, "${campaign.name}"?`,
        theme: confirmService.DELETE,
        template: `
        <div class="checkbox">
            <label><input type="checkbox" ng-model="deleteReviews"> </label>
        </div>`,
        initialModel: {deleteReviews: true}
      })
        .then((params) => {
          $scope.state = "Deleting";
          campaignManagerService.deleteCampaign(campaign, params.deleteReviews || false).then(function () {
            var updateInfo = {
              status: "Active",
              type: "campaign",
              title: "Campaign",
              destinationRole: "manage",
              notificationType: "detail",
              actions: [{action: "delete"}],
              entity: campaign,
              id: campaign._id,
              name: campaign.name,
              searchParam: campaign.name
            };
            updateService.registerSuccessfulUpdate(updateInfo, true);

          }).finally(() => $state.go("reviewBuilderEntry"));
        })
    };

    function drawHighCharts(reportData) {
      $timeout(function () {
        highcharts.chart(
          document.querySelector("#campaignSummaryChart"), {
          chart: {
            marginTop: 40,
            marginRight: 40
          },
          title: {
            text: ""
          },
          xAxis: {
            categories: ['Campaign Summary']
          },
          series: [
            {
              type: 'column',
              name: 'Total Reviews',
              data: [reportData.totalReviews]
            },
            {
              type: 'column',
              name: 'Click Throughs',
              data: [reportData.totalFormLinksClicked]
            },
            {
              type: 'column',
              name: 'Emails Opened',
              data: [reportData.totalEmailsOpened]
            },
            {
              type: 'column',
              name: 'Emails Sent',
              data: [reportData.totalEmailsSent]
            }]
        });
      }, 200);

    }



    $scope.toggleCollapse = function (item) {
      $scope.ui[item].collapse = !$scope.ui[item].collapse
    }

    $scope.updateConfig = {
      entityId: null,
      pageOneResult: true
    };

    function processActivation(response) {
      $scope.campaign = response;
      var status = "Active"
      var action = "activate"
      if (!response.isActive) {
        status = "Inactive"
        action = "deactivate"
      }
      var updateInfo = {
        status: status,
        type: "campaign",
        title: "Campaign",
        destinationRole: "manage",
        notificationType: "detail",
        actions: [{action: action}],
        entity: response,
        id: response._id,
        name: response.name,
      };
      updateService.registerSuccessfulUpdate(updateInfo, true);
    }

  });
};
